import { render, staticRenderFns } from "./MentionEditor.vue?vue&type=template&id=71a42b84&scoped=true"
import script from "./MentionEditor.vue?vue&type=script&lang=js"
export * from "./MentionEditor.vue?vue&type=script&lang=js"
import style0 from "./MentionEditor.vue?vue&type=style&index=0&id=71a42b84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a42b84",
  null
  
)

export default component.exports